import { render } from "./AddProductIcon.vue?vue&type=template&id=ec034460"
import script from "./AddProductIcon.vue?vue&type=script&lang=js"
export * from "./AddProductIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__